/*!
 * Built with Stencil
 *  Components for Katal Community Components
 *  Copyright (c) Amazon
 */
const BRAND_REGISTRY_URL = "https://sellercentral.amazon.com/tsba/searchpage/IP%20Accelerator";
const PUBLIC_BRAND_REGISTRY_URL = "https://sellercentral.amazon.com/gspn/searchpage/IP%20Accelerator";
const USPTO_URL = "https://www.uspto.gov/trademarks/apply";
/**
 * This value is an estimate for the time that it takes to load a batch of 6 generated names.
 * It is utilized within loading bars to estimate the progress on a "NextState" request with the "GenerateNames" action.
 */
const GENERATE_NAMES_AVERAGE_TIME_MILLISECONDS = 20000;

export { BRAND_REGISTRY_URL as B, GENERATE_NAMES_AVERAGE_TIME_MILLISECONDS as G, PUBLIC_BRAND_REGISTRY_URL as P, USPTO_URL as U };

//# sourceMappingURL=constants.js.map